import { getChatSession } from './getChatSession'

/**
 * @param {string} authorId
 */
export function isAgent(authorId) {
  const session = getChatSession()
  return session.users.some((u) => u.type === 'agent' && u.id === authorId)
}
